<template>
  <div class="details">
    <Details :crumbsConfig="crumbsConfig"/>
  </div>
</template>

<script>
export default {
  data() {
    return {
      crumbsConfig: [
        {
          url: "/",
          text: "首页"
        },
        {
          url: "/marketActivity/list",
          text: "市场活动"
        },
        {
          text: "活动详情"
        }
      ]
    };
  },
  created() {
  },
  methods: {}
};
</script>

<style scoped lang="scss">
@media (min-width: 751px) and (max-width: 960px) {
}
@media (min-width: 961px) {
}
</style>
